<template>
    <div id="dashboard-view">
        <teleport to="#sub-nav">
            <!-- <div class="button" @click="updateLogs">Pull Logs</div> -->
            <!-- <div class="button" @click="fetchAllPlayers">Reindex</div>
            <div class="button" @click="calculatePlayerStats">Update Interactions</div> -->
            
            <div class="filter-item">
                <label for="sort-by-input">Sort By </label>
                <select v-model="sort_by" id="sort-by-input">
                    <option 
                        v-for="field in sort_by_fields" 
                        :key="`sort-by-option-${field}`"
                        :value="field"
                    >
                        {{field}}
                    </option>
                </select>
                <select v-model="sort_by_dir" id="sort-by-dir-input">   
                    <option default value="desc">Descending</option>
                    <option default value="asc">Ascending</option>
                </select>
            </div>
        </teleport>

        

        <recycle-scroller id="items-scroller" :items="items" :item-size="65" key-field="id" v-slot="{item}">
            <div class="item-row">
                <img :src="item.image" class="item-image"/>
                <div class="item-middle">
                    <div>
                        <strong>{{item.name}}</strong>
                        <span> (${{this.toCurrency(item.market_value)}})</span>
                    </div>
                    <div>
                        <span style="opacity: 0.8;">{{item.description}}</span> 
                        <span v-if="item.weapon_type">{{item.weapon_type}}</span>
                    </div>
                    <div>
                        <span style="color: green;">{{item.effects}}</span> 
                        <span v-if="item.requirements" style="color: red;">{{item.requirements}}</span>
                    </div>

                </div>
            </div>
        </recycle-scroller>
    </div>
</template>

<script>


export default {
    name: 'Items',
    data() {
        return {
            sort_by: 'market_value',
            sort_by_dir: 'desc',
            sort_by_fields: [
                'market_value',
                'name',
                'id',
                'weapon_type'
            ]
        }
    },
    components: {
        // RecycleScroller
    },
    methods: {
       
        

        setSortBy(field) {
            if (this.sort_by === field) {
                this.sort_by_dir = this.sort_by_dir === 'asc' ? 'desc' : 'asc';
            } else this.sort_by = field;
        },

        sortItems(a, b) {
            let sign = this.sort_by_dir === 'desc' ? -1 : 1;
            let sort_by = this.sort_by.toLowerCase();
            let av = a[sort_by];
            let bv = b[sort_by];

            if (av < bv) return -1 * sign;
            else if (av > bv) return 1 * sign;
            else return 0;
        }
    },
    
    computed: {
        items() {
            return Object.values(this.$store.state.items).sort(this.sortItems);
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            // vm.$store.dispatch('getPlayers');
        })
    }
}
</script>
<style lang="scss">
    #dashboard-view {
        background-color: black;
    }

    #key-input-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    #items-scroller {
        min-height: 500px;
        width: 100%;
        height: 100vh;
    }

    #player-header {
        width: 100%;
        background-color: black;
    }

    .item-row {
        background-color: #3d3d3d;
        height: 65px;
        margin-bottom: 5px;
        padding: 10px;

        display: flex;

        // .left {
        //     // flex: 1;
        //     min-width: 300px;
        // }

        // .right {
        //     flex: 1;
        // }



        .left > div {
            display: flex;
            align-items: center;
        }

        .cell {
            margin-right: 8px;

            .key {
                font-size: 0.8rem;
                font-weight: bold;
            }
        }

        &:nth-child(even) {
            background-color: #4d4d4d;
        }
    }
    
    .item-middle {
        display: flex;
        flex-direction: column;
    }
</style>